import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreHeading,
  OreStack,
  OreText,
  SvgArrowWidgetRight,
} from '@edenredespana/oreneta'
import { useNavigate } from 'react-router-dom'

import { AdvertisementModel } from '@/Home/domain'
import { navigationRoutes } from '@/Shared/ui/routers'

interface AdvertisementModuleProps {
  advertisement: AdvertisementModel
}

export const AdvertisementModule = ({
  advertisement: { title, description, image, link, cta },
}: AdvertisementModuleProps): JSX.Element => {
  const navigate = useNavigate()
  const isRelativePath = link?.startsWith('/')

  const handleHrefRedirect = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault()
    isRelativePath
      ? navigate(link, { state: { origin: navigationRoutes.home } })
      : window.open(link, '_blank')
  }

  return (
    <div style={{ height: '479px' }}>
      <OreCardContainer
        ref={el => {
          if (el) {
            el.style.display = 'flex'
            el.style.flexDirection = 'column'
            el.style.height = '100%'
          }
        }}
      >
        <OreStack style={{ overflowX: 'hidden' }}>
          {link && cta ? (
            <a href="#" onClick={handleHrefRedirect}>
              <img style={{ width: '100%' }} src={image} alt={title} />
            </a>
          ) : (
            <img style={{ width: '100%' }} src={image} alt={title} />
          )}
        </OreStack>

        <OreCardWrapper
          ref={el => {
            if (el) {
              el.style.flex = '1'
            }
          }}
          space="small"
        >
          <OreStack
            direction="column"
            placeItems="start"
            placeContent="space-between"
            style={{ height: '100%' }}
            space="medium"
          >
            <OreStack direction="column">
              <OreHeading as="h4" size="headline-sm">
                {title}
              </OreHeading>
              <OreText>{description}</OreText>
            </OreStack>

            {cta && link && (
              <OreButton
                as="a"
                href="#"
                category="highlight"
                icon={<SvgArrowWidgetRight />}
                iconAlign="right"
                onClick={handleHrefRedirect}
              >
                {cta}
              </OreButton>
            )}
          </OreStack>
        </OreCardWrapper>
      </OreCardContainer>
    </div>
  )
}
